import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { AlertComponent } from 'app/popup/alert.component';
import { PermitTypeService } from 'app/services/permit-type.service';
import { AuthWebService } from 'app/services/authweb.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-permit-type',
  templateUrl: './permit-type.component.html',
  styleUrls: ['./permit-type.component.css']
})
export class PermitTypeComponent implements OnInit {

  form;
  pType: any = {};
  sub: any;
  lblHeading = '';
  btnActionLabel = '';
  isEdit: boolean;
  user = { LastName: '' };
  isDup = false;
  selectedDisplay = 3;
  message = null;
  selectedCat = 1;
  selectedPer = 1;
  listCats = [{ key: 1, value: 'Freight' }, { key: 2, value: 'Passenger' }];
  listPers = [{ key: 1, value: 'Temporary' }, { key: 2, value: 'Long-term' }];
  public isLoading = false;
  now = new Date();
  audit = { created: '', updated: '' };
  isValid: boolean = true;
  permitTypeList : any;

  constructor(private permitTypeService: PermitTypeService, private authWebService: AuthWebService,
    private router: Router,
    private route: ActivatedRoute,
     public utility: UtilityServiceService, private toastr: ToastrService) { }

  ngOnInit() {
    this.getPermitTypes();
    this.initForm();
    this.onChanges();
    this.listenChanges();
    this.user.LastName = (this.authWebService.userData) ? this.authWebService.userData.User.LastName : '';
    this.sub = this.route.params.subscribe(params => {
      if (this.router.url.indexOf('edit') != -1) {
        this.isEdit = true;
        this.lblHeading = 'Edit Permit Type';
        this.btnActionLabel = 'Update';
        const id = +params['id'];
        this.isLoading = true;
        this.permitTypeService.getById(id).subscribe(result => {
          console.log(result);
          this.pType = result;
          this.isLoading = false;
          (<UntypedFormGroup>this.form)
            .setValue({
              id: this.pType.id
              , code: this.pType.code
              , description: this.pType.description
              , product_link: this.pType.product_link
              , account_link: this.pType.account_link
              , application_product_link: this.pType.application_product_link
              , application_account_link: this.pType.application_account_link
              , current_fee: this.pType.current_fee
              , current_application_fee: this.pType.current_application_fee
              , temp_long_ind: this.pType.temp_long_ind
              , freight_passenger_ind: this.pType.freight_passenger_ind
              , permit_days: this.pType.permit_days
              , permit_months: this.pType.permit_months
              , permit_years: this.pType.permit_years
              , group_code: this.pType.group_code
              , sort_order: this.pType.sort_order
              , is_active: this.pType.is_active
              , display_ind: this.pType.display_ind
              , date_created: this.pType.date_created
              , date_modified: this.pType.date_modified
              , user_created: this.pType.user_created
              , user_modified: this.pType.user_modified
              , application: (this.pType.application) ? this.pType.application : null
              , num_renewals_allowed: this.pType.num_renewals_allowed
              , charge_when_ind: this.pType.charge_when_ind
              , is_permit: this.pType.is_permit
              , can_get_duplicate: this.pType.can_get_duplicate
              , can_replace_vehicle: this.pType.can_replace_vehicle
              , can_correct_error: this.pType.can_correct_error
              , can_change_annexure: this.pType.can_change_annexure
              , can_amend_owner: this.pType.can_amend_owner
              , can_amend_route: this.pType.can_amend_route
              , can_amend_timetable: this.pType.can_amend_timetable
              , association_reqd: this.pType.association_reqd
              , own_vehicle_reqd: this.pType.own_vehicle_reqd
              , one_start_date_reqd: this.pType.one_start_date_reqd
              , timetable_reqd: this.pType.timetable_reqd
              , annual_compliance_reqd: this.pType.annual_compliance_reqd
              , monthly_return_reqd: this.pType.monthly_return_reqd
              , certificate_return_reqd: this.pType.certificate_return_reqd
              ,can_specify_duration: this.pType.can_specify_duration
              , PermitTemplate : this.pType.PermitTemplate
              , isCompliancePermitType : this.pType.IsCompliancePermitType
              , Compliance_PermitType_Id : this.pType.Compliance_PermitType_Id == null || this.pType.Compliance_PermitType_Id == undefined || this.pType.Compliance_PermitType_Id == 0? 0 : this.pType.Compliance_PermitType_Id
              , canCreatePermit : this.pType.CanCreatePermit
            }, { onlySelf: true });
          this.audit = this.utility.setAuditAttributes(this.pType.date_created, this.pType.user_created, this.pType.date_modified, this.pType.user_modified);
        });
      } else {
        this.isEdit = false;
        this.lblHeading = 'New Permit Type';
        this.btnActionLabel = 'Save';
        this.audit = this.utility.setAuditAttributes(this.now, this.user.LastName, this.now, this.user.LastName);
      }
    });
  }

  getPermitTypes()
  {
    this.permitTypeService.getAll().subscribe((pTypes:any)=>{ 
      this.permitTypeList = pTypes.filter(f=>f.description.toLowerCase().indexOf("annual compliance") > 0);
    });
  }

  initForm() {
    this.form = new UntypedFormGroup({
      id: new UntypedFormControl()
      , code: new UntypedFormControl(this.pType.code, )
      , description: new UntypedFormControl(this.pType.description, Validators.maxLength(100))
      , product_link: new UntypedFormControl(this.pType.product_link, Validators.maxLength(20))
      , account_link: new UntypedFormControl(this.pType.account_link, Validators.maxLength(20))
      , application_product_link: new UntypedFormControl(this.pType.application_product_link, Validators.maxLength(20))
      , application_account_link: new UntypedFormControl(this.pType.application_account_link, Validators.maxLength(20))
      , current_fee: new UntypedFormControl()
      , current_application_fee: new UntypedFormControl()
      , temp_long_ind: new UntypedFormControl()
      , freight_passenger_ind: new UntypedFormControl()
      , permit_days: new UntypedFormControl(0, Validators.compose([this.utility.checkIntegerType]))
      , permit_months: new UntypedFormControl(0, Validators.compose([this.utility.checkIntegerType]))
      , permit_years: new UntypedFormControl(0, Validators.compose([this.utility.checkIntegerType]))
      , group_code: new UntypedFormControl(this.pType.group_code, Validators.compose([Validators.required, Validators.maxLength(12)]))
      , sort_order: new UntypedFormControl(this.pType.sort_code, Validators.required)
      , is_active: new UntypedFormControl()
      , display_ind: new UntypedFormControl(this.pType.display_ind, Validators.required)
      , date_created: new UntypedFormControl()
      , date_modified: new UntypedFormControl()
      , user_created: new UntypedFormControl()
      , user_modified: new UntypedFormControl()
      , application: new UntypedFormControl()
      , num_renewals_allowed: new UntypedFormControl(0, Validators.compose([this.utility.checkIntegerType]))
      , charge_when_ind: new UntypedFormControl(0, Validators.compose([this.utility.checkIntegerType]))
      , is_permit: new UntypedFormControl(true)
      ,can_specify_duration : new UntypedFormControl(false)
      , can_get_duplicate: new UntypedFormControl(true)
      , can_replace_vehicle: new UntypedFormControl(true)
      , can_correct_error: new UntypedFormControl(true)
      , can_change_annexure: new UntypedFormControl(true)
      , can_amend_owner: new UntypedFormControl(true)
      , can_amend_route: new UntypedFormControl(true)
      , can_amend_timetable: new UntypedFormControl(true)
      , annual_compliance_reqd: new UntypedFormControl(false)
      , association_reqd: new UntypedFormControl(false)
      , own_vehicle_reqd: new UntypedFormControl(false)
      , one_start_date_reqd: new UntypedFormControl(false)
      , timetable_reqd: new UntypedFormControl(false)
      , monthly_return_reqd: new UntypedFormControl(true)
      , certificate_return_reqd: new UntypedFormControl(true)
      , PermitTemplate : new UntypedFormControl("Permit")
      , isCompliancePermitType : new UntypedFormControl(false)
      , Compliance_PermitType_Id : new UntypedFormControl("")
      , canCreatePermit : new UntypedFormControl(true)

    });
    this.form.patchValue(this.utility.defaults);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  onSubmit(obj: any) {
    if (this.isDup) { return; }
    this.validInputGroup();
    if (!this.isValid) {
      return;
    }
    this.pType = obj;
    console.log(this.pType);
    this.message = (this.isEdit) ? "Updating Permit Type" : "Adding a new Permit Type";
    if (this.isEdit) {
      let modified = new Date().toLocaleString();
      //console.log(modified);
      this.pType.date_modified = new Date().toLocaleString();
      this.pType.user_modified = this.user.LastName;
      this.isLoading = true;
      this.permitTypeService.update(this.pType).subscribe(result => {
        this.pType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Permit Type', message: `Permit Type ${this.pType.code} updated succesfully.`, bold: `${this.pType.code}` });
        this.toastr.success(`Permit Type ${this.pType.code} updated succesfully.`, 'Update Permit Type');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'Update Permit Type', message: `Permit Type ${this.pType.code} was not updated succesfully.`, bold: `${this.pType.code}` });
        this.toastr.error(`Permit Type ${this.pType.code} was not updated succesfully.`, 'Update Permit Type');

      });
    } else {
      this.pType.date_modified = this.pType.date_created = new Date().toLocaleString();
      this.pType.user_modified = this.pType.user_created = this.user.LastName;
      this.pType.code = this.generateUID();
      this.isLoading = true;
      
      //console.log(this.generateUID());
      console.dir(this.pType);
      this.permitTypeService.add(this.pType).subscribe(result => {
        this.pType = result;
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Permit Type', message: `New Permit Type ${this.pType.code} added successfully.`, bold: `${this.pType.code}` });
        this.toastr.success(`New Permit Type ${this.pType.code} added successfully.`, 'New Permit Type');
        this.navigate();
      }, error => {
        this.isLoading = false;
        // this.dialogService.addDialog(AlertComponent, { title: 'New Permit Type', message: `New Permit Type ${this.pType.code} was not added successfully.`, bold: `${this.pType.code}` });
        this.toastr.error(`New Permit Type ${this.pType.code} was not added successfully.`, 'New Permit Type');
      });
    }
  }
  generateUID() {
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    var f = firstPart.toString();
    var s = secondPart.toString();
    f = (("000" + firstPart.toString(36)).slice(-3));
    s = ("000" + secondPart.toString(36)).slice(-3);
    return f + s;
}

  navigate() {
    this.router.navigateByUrl('/permit/type/list');
  }


  onChanges(): void {
    this.form.get('code').valueChanges.subscribe(code => {

      if (code.length > 3) {
        this.permitTypeService.checkByCode(code.trim()).subscribe((result:any) => {
          this.isDup = (result.Status && !this.isEdit) ? true : false;
        }, error => {
          this.isDup = false;

        });
      }
    });
  }



  checkPeriod = (ctrlName: any, ctrlIndex) => {

    let period = this.form.get(ctrlName).value;
    if (period > 0) {
      switch (ctrlIndex) {
        case 1:
          this.form.patchValue({ permit_months: 0, permit_years: 0 });
          break;
        case 2:
          this.form.patchValue({ permit_days: 0, permit_years: 0 });
          break;
        case 3:
          this.form.patchValue({ permit_months: 0, permit_days: 0 });
          break;
      }
    }
    //this.validInputGroup();    
  }

  validInputGroup = (): any => {
    this.isValid = false;
    let condition = + this.form.get("permit_years").value + this.form.get("permit_months").value + this.form.get("permit_days").value;
    this.isValid = (condition == 0) ? false : true;

    if(this.form.get("isCompliancePermitType").value == true && this.form.get("Compliance_PermitType_Id").value == 0)
    {
      this.toastr.error("Please select Permit Type for Annual Compliance");
      this.isValid = false;
      return;
    }
  }

  listenChanges(): void {
    this.form.valueChanges.subscribe(val => {
      let ctrlIndex = +  val.permit_days + val.permit_months + val.permit_years;
      if (this.form.valid) {
        this.isValid = (ctrlIndex >= 1) ? true : false;
      }
    });
  }

  enableSubmit = () => {
    return !(this.form.valid && this.isValid);
  }
}
